const NAMED_ENTITIES: Record<string, string> = {
  amp: "&",
  apos: "'",
  gt: ">",
  lt: "<",
  nbsp: " ",
  quot: '"',
};

const decodeEntity = (entity: string): string | null => {
  const normalized = entity.toLowerCase();

  if (normalized.startsWith("#x")) {
    const codePoint = Number.parseInt(normalized.slice(2), 16);
    return Number.isFinite(codePoint) ? String.fromCodePoint(codePoint) : null;
  }

  if (normalized.startsWith("#")) {
    const codePoint = Number.parseInt(normalized.slice(1), 10);
    return Number.isFinite(codePoint) ? String.fromCodePoint(codePoint) : null;
  }

  return NAMED_ENTITIES[normalized] ?? null;
};

const decodeHtmlEntitiesOnce = (value: string): string => {
  return value.replace(
    /&(#x[0-9a-f]+|#\d+|[a-z][a-z0-9]+);/gi,
    (match, entity) => decodeEntity(entity) ?? match,
  );
};

export const decodeHtmlEntities = (value: string): string => {
  let decoded = value;

  for (let i = 0; i < 3; i += 1) {
    const nextDecoded = decodeHtmlEntitiesOnce(decoded);
    if (nextDecoded === decoded) {
      break;
    }
    decoded = nextDecoded;
  }

  return decoded;
};
